import React, { useMemo, useState } from "react";
import { FormattedMessage } from "react-intl";
import AppContainer from "../../components/layout/AppContainer";
import * as Yup from "yup";
import IntlTranslate from "../../helpers/IntlTranslate";
import { useFormik, Form, FormikProvider } from "formik";
import { Stack, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import withTitle from "../../helpers/hoc/withTitle";
import SnackbarComponent from "../../components/Snackbar";
import { CreateBus } from "../../api/api";

function BusesAdd() {
  const breadcrumb = useMemo(
    () => [
      {
        name: <FormattedMessage id="buses" />,
        path: "/buses",
      },
      { name: <FormattedMessage id="buses.add" />, active: true },
    ],
    []
  );
  const [loading, setLoading] = useState(false);
  // Snackbar Props
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarType, setSnackbarType] = useState("success");
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };
  // Snackbar Props
  const schema = Yup.object().shape({
    busName: Yup.string(),
    busPlate: Yup.string().required(IntlTranslate("busPlate.required")),
  });
  const formik = useFormik({
    initialValues: {
      busPlate: "",
      busName: "",
    },
    validationSchema: schema,
    onSubmit: async (datas, { resetForm }) => {
      setLoading(true);
      let response = await CreateBus({
        Id: 0,
        Plate: datas.busPlate,
        Name: datas.busName,
      });
      if (response.data.status === "success" && response.data.Id) {
        resetForm();
        setSnackbarType("success");
        setSnackbarOpen(true);
      } else {
        setSnackbarType("error");
        setSnackbarOpen(true);
      }
      setLoading(false);
    },
  });
  const { errors, touched, handleSubmit, getFieldProps } = formik;
  return (
    <AppContainer breadcrumbs={breadcrumb}>
      <FormikProvider value={formik}>
        <Form onSubmit={handleSubmit}>
          <Stack sx={{ mt: 1 }} spacing={3}>
            <Stack direction={{ xs: "column", lg: "row" }} spacing={2}>
              <TextField
                required
                fullWidth
                label={IntlTranslate("busPlate")}
                {...getFieldProps("busPlate")}
                error={Boolean(touched.busPlate && errors.busPlate)}
                helperText={touched.busPlate && errors.busPlate}
              />
              <TextField
                fullWidth
                label={IntlTranslate("busName")}
                {...getFieldProps("busName")}
                error={Boolean(touched.busName && errors.busName)}
                helperText={touched.busName && errors.busName}
              />
            </Stack>
            <LoadingButton
              type="submit"
              fullWidth
              variant="contained"
              color="success"
              sx={{ mt: 3, mb: 2 }}
              loading={loading}>
              <FormattedMessage id="add" />
            </LoadingButton>
          </Stack>
        </Form>
      </FormikProvider>
      <SnackbarComponent
        open={snackbarOpen}
        successMessage={IntlTranslate("bussuccessadd")}
        alertType={snackbarType}
        onClose={handleClose}
      />
    </AppContainer>
  );
}

export default withTitle(BusesAdd, "buses.add");
